<script lang="ts">
    import { Col ,Row} from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {oneColumnwidth, oneColumnwidthMessage} from "../../../utils/Constant/Constant"
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={oneColumnwidth} CardBodyprops="grid-showcase">
      <div slot="contentbody">
        <p>{@html oneColumnwidthMessage}</p>
        <Row>
            <div class="col">
                <span>1 of 3</span>
            </div>
            <div class="col-6">
                <span>2 of 3 (wider)</span>
            </div>
            <div class="col">
                <span> 3 of 3</span>
            </div>
        </Row>
        <Row>
            <div class="col">
                <span>1 of 3</span>
            </div>
            <div class="col-5">
                <span> 2 of 3 (wider)</span>
            </div>
            <div class="col">
                <span>3 of 3</span>
            </div>
        </Row>
      </div>
    </Card>
</Col>